// React and Router 
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// MUI and Material Dashboard components
import CloseIcon from '@mui/icons-material/Close';
import VisibilityTwoToneIcon from "@mui/icons-material/VisibilityTwoTone";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";

// E4A react components and helper functions
import DataTable from "e4acomponents/Tables/DataTable";
import { convertDate } from "../helperFunctions";

export default function ViewOrderProducts({
    products,
    open,
    handleClose,
    orderNum
}) {
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (open && Array.isArray(products) && products.length > 0) {
            setTableData(getRows(products));
        } else {
            setTableData([]);
        }
    }, [open])

    // Formats product data to fit table structure
    const getRows = (info) => {
        let updatedInfo = info
            .map((e) => {
                return {
                    id: e._id,
                    serialNumber: e.serialNumber,
                    firmwareVersion: e.firmwareVersion,
                    dateOfStorage: convertDate(e.dateOfStorage),
                    shelfLife: `${e.shelfLife[0]} ${e.shelfLife[1]}`,
                }
            })
        return updatedInfo;
    }

    // Defines the structure and content of the data table
    const dataTableData = {
        columns: [
            { Header: "Serial Number", accessor: "serialNumber" },
            { Header: "Firmware Version", accessor: "firmwareVersion" },
            { Header: "Date of Storage", accessor: "dateOfStorage" },
            { Header: "Shelf Life", accessor: "shelfLife" },
            {
                Header: "Actions",
                accessor: "actions",
                disableSortBy: true,
                Cell: ({ row }) => {
                    return (
                        // Action button to view product details
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="View Product">
                                <IconButton
                                    onClick={() =>
                                        window.open(
                                            `/fulfillment-center/view-product/${row.original.id}`,
                                            "_blank",
                                            "noopener,noreferrer"
                                        )
                                    }
                                >
                                    <VisibilityTwoToneIcon color="info" />
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    )
                }
            }
        ],
        rows: tableData,
    }
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xl">
            
            {/* Dialog Header */}
            <DialogTitle>
                <MDBox display="flex" justifyContent="space-between">
                    
                    {/* Title */}
                    <MDBox>
                        Order#{orderNum} Products
                    </MDBox>

                    {/* Close Button */}
                    <MDBox>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </MDBox>

                </MDBox>
            </DialogTitle>
            
            {/* Dialog Content */}
            <DialogContent>
                
                {/* Dialog sub-title */}
                <DialogContentText>
                    Products associated with this order:
                </DialogContentText>
                
                {/* Data Table */}
                {tableData.length > 0 ? (
                    <DataTable
                        table={dataTableData}
                        isSorted={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        noEndBorder
                        tableId="order-products-table"
                    />
                ) : ( // Message when no products are assigned
                    <MDBox
                        mt={2}
                        width="80vh"
                        height="40vh"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        textAlign="center"
                    >
                        No products assigned yet
                    </MDBox>
                )}
                
            </DialogContent>
        </Dialog>
    )
}